import { useCallback } from "react"

import { RichText, RichTextViewer } from "simplydo/react/richtext"

// Ideas are a bit poorly optimised when it comes to updates, by wrapping the handlers a bit differently for fields we save a decent amount of unnecessary updates
const RichTextField = ({ ideaId, field, fieldValue = "", updateIdea, isEditing, inputRef, handleKeyDown }) => {
  const onChange = useCallback((html) => updateIdea(html, ["templated", field.id]), [updateIdea, field.id])

  if (!isEditing) return <RichTextViewer content={fieldValue} forType="idea" forId={ideaId} />
  return (
    <RichText
      stickyMenu={true}
      stickyMenuOffset={140}
      emptyReturnValue={null}
      historyEnabled={false}
      onChange={onChange}
      forType="idea"
      forId={ideaId}
      value={fieldValue}
      editorRef={inputRef}
      handleKeyDown={handleKeyDown}
    />
  )
}

export default RichTextField
